/**
 * Function to handle pluralizations in ICU message format
 * @param {icuString} string ICU message as string
 * @returns {string} A string matching the count, with `#` placeholders replaced with count
 */
function pluralize(count, icuString) {
  var regx = /(?:=?(\d|other)){([^{}]*)}/gim
  var matches = icuString.match(regx)

  if (!matches) {
    console.error('pluralize could not parse the input: ' + icuString)
    return icuString
  }

  var options = matches.reduce(function(obj, str) {
    str.replace(regx, function(match, p1, p2) {
      obj[p1] = p2.replace(/#/gm, count)
    })
    return obj
  }, {})

  return count && count > 1 ? options.other : options[count] || options['0']
}

module.exports = pluralize
